// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"783be968","239":"da3502be","455":"7492b86c"}[chunkId] + ".chunk.js";
};